import socialLoginErrors from "@casino/legacy/client/components/Auth/Shared/utils/socialLoginErrors";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import { getCookie } from "@workspace/cookies/browser";

const SocialLoginError = () => {
  const loginErrors = getCookie("loginError") as string;
  const errorList = loginErrors?.split(",");
  const loginError = errorList?.find((error) =>
    socialLoginErrors.includes(error),
  );
  if (!loginError) {
    return null;
  }
  const errorMessage = `errors.${loginError}`;
  return (
    <div className="grid gap-2">
      <p className="text-xs text-primary">
        <Translate id={errorMessage} />
      </p>
    </div>
  );
};

export default SocialLoginError;
